import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Topbar from '@templates/dashboard/Topbar';
import ActivateFinariumCard from '@molecules/wrappers/ActivateFinariumCard';
import ActivateMagmaCard from '@molecules/wrappers/ActivateMagmaCard';
import ActivateUnifyCard from '@molecules/wrappers/ActivateUnifyCard';
import axios from 'axios';
import api from 'API';
import FinariumBalanceCard from '@molecules/wrappers/FinariumBalanceCard';
import MagmaBalanceCard from '@molecules/wrappers/MagmaBalanceCard';
import UnifyBalanceCard from '@molecules/wrappers/UnifyBalanceCard';
import Spinner from '@atoms/spinner';
import './home.less';
import ExchangeCard from '@templates/dashboard/transfer-cards/ExchangeCard';
import QuickTransferCard from '@templates/dashboard/transfer-cards/QuickTransferCard';
import CardPayments from '@molecules/wrappers/CardPayments';
import { clearUserToken } from '@features/userTokenSlice';
import { tConsume } from 'TRANSLATION';
import { connect, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import ActivateMonestoCard from '@molecules/wrappers/ActivateMonestoCard';
import MonestoBalanceCard from '@molecules/wrappers/MonestoBalanceCard';
import merge from 'deepmerge';
import notification from '@helps/notification';

const Home = ({
  userType,
  magmaToken,
  finariumToken,
  finariumUrl,
  unifyToken,
  unifyUrl,
  monestoToken,
  monestoUrl,
  oauthSuccess,
  clearUserToken,
}) => {
  const configs = merge(require('ROOT/configs.json'), require('ROOT/configs.prod.json'), {
    arrayMerge: (target, source) => [...new Set([...target, ...source])],
  });
  const specialUsers = configs.variables.magma_and_monesto_users;
  const userIds = useSelector((state) => state.personal.customers_ids);
  const isDoubleAccountMagmaMonesto = useSelector((state) => state.personal.doubleAccountMagmaMonesto);

  const isSpecialUser = specialUsers?.some((item) => userIds.includes(item)) || isDoubleAccountMagmaMonesto;

  const [balanceMagma, setBalanceMagma] = useState(null);
  const [balanceFinarium, setBalanceFinarium] = useState(null);
  const [balanceUnify, setBalanceUnify] = useState(null);
  const [balanceMonesto, setBalanceMonesto] = useState(null);

  const popupRef = useRef(null);
  const intervalRef = useRef(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [firstLoginFinarium, setFirstLoginFinarium] = useState(false);
  const [firstLoginMagma, setFirstLoginMagma] = useState(false);
  const [firstLoginUnify, setFirstLoginUnify] = useState(false);
  const [firstLoginMonesto, setFirstLoginMonesto] = useState(false);
  const history = useHistory();

  useEffect(() => {
    fetchInitialData();
    checkServiceSpace();
    setIsLoading(false);
  }, []);

  const fetchInitialData = useCallback(async () => {
    try {
      const [balancesResponse] = await Promise.all([axios(api.users.dashboardBalances().AXIOS('GET'))]);

      const magmaBalance = balancesResponse.data.find((el) => el.slug === 'magma');
      const finariumBalance = balancesResponse.data.find((el) => el.slug === 'finarium');
      const unifyBalance = balancesResponse.data.find((el) => el.slug === 'lava');
      const monestoBalance = balancesResponse.data.find((el) => el.slug === 'monesto');

      setBalanceMagma(magmaBalance?.balances || null);
      setBalanceFinarium(finariumBalance?.balances || null);
      setBalanceUnify(unifyBalance?.balances || null);
      setBalanceMonesto(monestoBalance?.balances || null);
    } catch (err) {
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    const messageHandler = (event) => {
      // В продакшене нужно проверять origin сообщения!
      // if (event.origin !== 'https://your-app.com') return;

      // //console.log('Received message:', event.data);

      // Проверяем структуру данных
      if (event.data && event.data.user) {
        const tokenData = event.data;

        // Закрываем popup
        closePopup();

        // Обрабатываем полученные данные
        oauthSuccess();
        fetchInitialData();
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
      closePopup();
    };
  }, []);

  const logout = () => {
    clearUserToken();
    history.replace('/');
  };

  const registerOauth = async (space, newPopup) => {
    try {
      setIsLoading(true);
      const response = await axios(api.users.registration.spacesRegister().AXIOS('POST', { spaces: [space] }));

      if (response.status === 403) {
        return;
      }

      if (space === 'monesto') {
        const response = await axios(api.users.registration.changeRiskLevel().AXIOS('POST'));
      }
      // const finToken = response.data?.finarium?.token?.access_token;
      // const unifyToken = response.data?.unify?.token?.access_token;
      // console.log('finToken', finToken);
      // console.log('unifyToken', unifyToken);

      const spaceToken = response.data[space]?.token?.access_token;
      console.log('spaceToken', spaceToken);

      openAuthPopup(space, true, spaceToken, newPopup);
    } catch (e) {
      if (e?.response?.status === 403) {
        if (newPopup && !newPopup.closed) {
          newPopup.close();
        }
        if (e.response?.data?.message) {
          notification(e.response?.data?.message, 'error');
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const oauthWithRegistration = (space, newPopup) => {
    registerOauth(space, newPopup);
  };

  const checkServiceSpace = async () => {
    const responseCheck = await axios(
      api.users.registration.checkSpaces().AXIOS('POST', { spaces: ['finarium', 'magma', 'lava', 'monesto'] })
    );

    responseCheck.data['finarium'] ? setFirstLoginFinarium(false) : setFirstLoginFinarium(true);
    responseCheck.data['magma'] ? setFirstLoginMagma(false) : setFirstLoginMagma(true);

    responseCheck.data['lava'] ? setFirstLoginUnify(false) : setFirstLoginUnify(true);
    responseCheck.data['monesto'] ? setFirstLoginMonesto(false) : setFirstLoginMonesto(true);
  };

  const handleActivateAccess = (space) => {
    closePopup();

    if (firstLoginFinarium || firstLoginMagma || firstLoginUnify || firstLoginMonesto) {
      const width = 600;
      const height = 700;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      const newPopup = window.open(
        'about:blank',
        'oauth_' + Date.now(), // Уникальное имя
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
      );

      if (newPopup) {
        if (space === 'finarium') {
          newPopup.document.write(`
            <html lang="en">
              <body style="
                margin: 0;
                padding: 40px;
                background: #f8f9fa;
                color: #333;
                height: 100vh;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
              ">
                <div>
                  <h2 style="margin-bottom: 30px; font-weight: 600;">
                    Please do not close this page. We are opening your Fin.Club account and Finarium.
                    This delay is a one-time event and will not occur again when using the platform.
                  </h2>

                  <div style="
                    width: 40px;
                    height: 40px;
                    border: 3px solid #FFF;
                    border-top: 3px solid #FFB33C;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin: 0 auto;
                  "></div>

                   <style>
                      @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }
                      }
                  </style>
                </div>
              </body>
            </html>
            `);
          newPopup.document.close();
        }

        if (space === 'lava') {
          newPopup.document.write(`
            <html lang="en">
              <body style="
                margin: 0;
                padding: 40px;
                background: #f8f9fa;
                color: #333;
                height: 100vh;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
              ">
                <div>
                  <h2 style="margin-bottom: 30px; font-weight: 600;">
                    Please do not close this page. We are opening your Fin.Club account and Lava.
                    This delay is a one-time event and will not occur again when using the platform.
                  </h2>

                  <div style="
                    width: 40px;
                    height: 40px;
                    border: 3px solid #FFF;
                    border-top: 3px solid #FFB33C;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin: 0 auto;
                  "></div>

                   <style>
                      @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }
                      }
                  </style>
                </div>
              </body>
            </html>
            `);
          newPopup.document.close();
        }

        if (space === 'monesto') {
          newPopup.document.write(`
            <html lang="en">
              <body style="
                margin: 0;
                padding: 40px;
                background: #f8f9fa;
                color: #333;
                height: 100vh;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
              ">
                <div>
                  <h2 style="margin-bottom: 30px; font-weight: 600;">
                    Please do not close this page. We are opening your Fin.Club account and Monesto.
                    This delay is a one-time event and will not occur again when using the platform.
                  </h2>

                  <div style="
                    width: 40px;
                    height: 40px;
                    border: 3px solid #FFF;
                    border-top: 3px solid #FFB33C;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin: 0 auto;
                  "></div>

                   <style>
                      @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }
                      }
                  </style>
                </div>
              </body>
            </html>
            `);
          newPopup.document.close();
        }
      }

      if (!newPopup) {
        throw new Error('Popup blocked. Please allow popups for this site.');
      }

      oauthWithRegistration(space, newPopup);
    } else {
      logout();
    }
  };

  // Функция открытия popup окна
  const openAuthPopup = async (space, firstLogin, spaceToken, newPopup) => {
    try {
      popupRef.current = newPopup;

      let authUrl = await getAuthUrl(space);
      const additionalParams = { first_login: firstLogin };
      const queryString = new URLSearchParams(additionalParams).toString();
      authUrl += (authUrl.includes('?') ? '&' : '?') + queryString;

      console.log('Добавляем дополнительный параметр first_login', authUrl);

      newPopup.location.href = authUrl;

      // Функция отправки данных
      const sendTokenData = () => {
        try {
          const messageData = {
            type: 'SET_TOKEN',
            token: spaceToken,
            tokenUserType: userType,
          };

          if (space === 'finarium') {
            console.log('адрес  для postMessage', finariumUrl);
            newPopup.postMessage(messageData, finariumUrl);
          }

          if (space === 'lava') {
            console.log('адрес  для postMessage', unifyUrl);
            newPopup.postMessage(messageData, unifyUrl);
          }

          if (space === 'monesto') {
            console.log('адрес  для postMessage', monestoUrl);
            newPopup.postMessage(messageData, monestoUrl);
          }

          console.log('✅ Данные отправлены в iframe:', messageData);
          return true;
        } catch (error) {
          console.warn('⚠️ Не удалось отправить данные в iframe:', error);
          return false;
        }
      };

      // Стратегия отправки:
      // 1. Сразу после открытия (быстрая попытка)
      setTimeout(sendTokenData, 100);

      // 2. После загрузки iframe
      newPopup.onload = () => {
        console.log('🔄 Iframe загружен, отправляем данные...');
        setTimeout(() => sendTokenData(), 300);
        setTimeout(() => sendTokenData(), 1000);
      };

      setTimeout(() => sendTokenData(), 5000);
      setTimeout(() => sendTokenData(), 10000);
      setTimeout(() => sendTokenData(), 20000);

      // 3. Периодические попытки в течение 5 секунд
      let sendAttempts = 0;
      const maxAttempts = 20;
      const sendInterval = setInterval(() => {
        if (newPopup.closed) {
          clearInterval(sendInterval);
          return;
        }

        if (sendAttempts < maxAttempts) {
          const success = sendTokenData();
          sendAttempts++;

          if (success) {
            console.log('✅ Данные успешно доставлены');
            clearInterval(sendInterval);
          }
        } else {
          console.warn('❌ Не удалось отправить данные после всех попыток');
          clearInterval(sendInterval);
        }
      }, 1000);

      // Проверка закрытия popup
      intervalRef.current = setInterval(() => {
        if (newPopup.closed) {
          clearInterval(sendInterval);
          clearPopupInterval();
          popupRef.current = null;
          setError('Authentication was cancelled');
        }
      }, 1000);
    } catch (err) {
      setError(err.message);
    }
  };
  // Закрытие popup
  const closePopup = () => {
    if (popupRef.current && !popupRef.current.closed) {
      popupRef.current.close();
      popupRef.current = null;
    }
    clearPopupInterval();
  };

  // Очистка интервала
  const clearPopupInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // Функция для получения URL авторизации
  const getAuthUrl = async (space) => {
    try {
      setError(null);

      const response = await axios(api.users.authorization.loginByOauth(space).AXIOS('GET'));

      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      console.log('getAuthUrl', response.data.url);

      return response.data.url;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
    }
  };

  const renderMagmaCards = () => {
    if (isSpecialUser) {
      // Для специальных пользователей - только Magma
      return (
        <>
          {!magmaToken && <ActivateMagmaCard activateAccess={handleActivateAccess} firstLoginMagma={firstLoginMagma} />}
          {magmaToken && <MagmaBalanceCard balanceMagma={balanceMagma} />}
        </>
      );
    } else {
      // Для обычных пользователей - Magma с учетом Monesto
      return (
        <>
          {!magmaToken && !monestoToken && (
            <ActivateMagmaCard activateAccess={handleActivateAccess} firstLoginMagma={firstLoginMagma} />
          )}
          {magmaToken && !monestoToken && <MagmaBalanceCard balanceMagma={balanceMagma} />}
        </>
      );
    }
  };

  return (
    <div className='content'>
      <Topbar userType={userType} />
      {isLoading ? (
        <section>
          <Spinner />
        </section>
      ) : (
        <section>
          <div className='main-block'>
            {renderMagmaCards()}

            {!finariumToken && (
              <ActivateFinariumCard
                activateAccess={handleActivateAccess}
                firstLoginFinarium={firstLoginFinarium}
                isLoading={!isLoading}
              />
            )}
            {finariumToken && <FinariumBalanceCard balanceFinarium={balanceFinarium} />}
            {!unifyToken && (
              <ActivateUnifyCard activateAccess={handleActivateAccess} firstLoginUnify={firstLoginUnify} />
            )}
            {unifyToken && <UnifyBalanceCard balanceUnify={balanceUnify} />}
            {!monestoToken && (
              <ActivateMonestoCard
                activateAccess={handleActivateAccess}
                firstLoginMonesto={firstLoginMonesto}
                isSpecialUser={isSpecialUser}
              />
            )}
            {monestoToken && <MonestoBalanceCard balanceMonesto={balanceMonesto} />}
            <ExchangeCard
              onUpdateBalance={fetchInitialData}
              // disabledFinarium={!finariumToken}
              monestoToken={!!monestoToken}
            />
            <QuickTransferCard
              onUpdateBalance={fetchInitialData}
              // disabled={!finariumToken}
              monestoToken={!!monestoToken}
            />
            <CardPayments />
          </div>
        </section>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userToken: state.userToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearUserToken: (path) => dispatch(clearUserToken(path)),
  };
};

export default tConsume(connect(mapStateToProps, mapDispatchToProps)(withRouter(Home)));

Home.propTypes = {
  userType: PropTypes.string,
  magmaToken: PropTypes.string,
  finariumToken: PropTypes.string,
  finariumUrl: PropTypes.string,
  unifyToken: PropTypes.string,
  unifyUrl: PropTypes.string,
  monestoToken: PropTypes.string,
  monestoUrl: PropTypes.string,
  oauthSuccess: PropTypes.func,
  clearUserToken: PropTypes.func.isRequired,
  userToken: PropTypes.object,
};
